import React, {useState, useEffect} from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { CircularProgress, Box, Typography } from '@material-ui/core';
import { useStyles } from './styles';

import generalTermsMd from '../../../assets/terms/general-terms-v1.md';
import saasAgreementMd from '../../../assets/terms/saas-agreement-v1.md';

const TermsMarkdownContent = () => {
  const classes = useStyles();
  const [generalTerms, setGeneralTerms] = useState('');
  const [saasAgreement, setSaasAgreement] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;

    setLoading(true);
    Promise.all([
      fetch(generalTermsMd).then(res => res.text()),
      fetch(saasAgreementMd).then(res => res.text()),
    ]).then(([general, saas]) => {
        if (cancelled) return;
        setGeneralTerms(general);
        setSaasAgreement(saas);
        setLoading(false);
      }).catch(() => {
        if (!cancelled) setLoading(false);
      });
    return () => { cancelled = true; };
  }, []);

  if (loading) {
    return (
      <Box display="flex" flexDirection="column" justifyContent="center" alignItems="center" minHeight={300}>
        <CircularProgress size="3rem" disableShrink />
        <Typography variant="body2" style={{ marginTop: 16, color: '#666' }}>
          Loading...
        </Typography>
      </Box>
    );
  }

  return (
    <div className={classes.markdownContent}>
      <ReactMarkdown remarkPlugins={[remarkGfm]}>{generalTerms}</ReactMarkdown>
      <hr className={classes.divider} />
      <ReactMarkdown remarkPlugins={[remarkGfm]}>{saasAgreement}</ReactMarkdown>
    </div>
  );
};

export default TermsMarkdownContent;
